import { SET_SELECTED_CARD_REQUEST_ID } from '@Actions/cardRequestsActions';
export const defaultState = {
    selectedCardRequestId: null
};
export function cardRequestsReducer(state = defaultState, action) {
    switch (action.type) {
        case SET_SELECTED_CARD_REQUEST_ID:
            return Object.assign(Object.assign({}, state), { selectedCardRequestId: action.payload });
        default:
            return state;
    }
}
